// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pc-navigation-horizontal[data-v-696ec927]>:not(template)~:not(template){padding-left:.4rem;padding-right:.4rem}@media (min-width:1280px){.pc-navigation-horizontal[data-v-696ec927]>:not(template)~:not(template){padding-left:.75rem;padding-right:.75rem}}", ""]);
// Exports
module.exports = exports;
